<template>
  <div :class="$style.container">

    <div :class="$style.mainSection">
      <div :class="$style.imageSection">
        <img v-if="userData.imageUrl" :src="userData.imageUrl" :class="$style.profileImage" alt="Профайл зураг" />
        <div v-else :class="$style.uploadPlaceholder">
          <span>No Image</span>
        </div>
      </div>
      <div :class="$style.infoSection">
        <div :class="$style.nameSection">
          <h2>{{ userData.lastname || '' }} {{ userData.firstname || '' }} </h2>
          <h5>{{ userData.degree.join(', ') }}</h5>
        </div>

        <div :class="$style.linksSection">
          <!-- Facebook Button -->
          <a :href="facebookLink || '#'" class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg"
            :class="{ [$style.disabled]: !facebookLink }" target="_blank" :disabled="!facebookLink">
            <i class="fa fa-facebook-square"></i>
          </a>

          <!-- Twitter Button -->
          <a :href="twitterLink || '#'" class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg"
            :class="{ [$style.disabled]: !twitterLink }" target="_blank" :disabled="!twitterLink">
            <i class="fa fa-twitter"></i>
          </a>
        </div>
      </div>
    </div>

    <div :class="$style.educationSection">
      <h3>Багшийн танилцуулга</h3>
      <ul>
        <li v-for="(education, index) in userData.education" :key="index">
          {{ education || 'Мэдээлэл байхгүй' }}
        </li>
      </ul>
    </div>
    <div :class="$style.titlePart">
      <h3 class="p-4">Сургалтууд</h3>
      <div :class="$style.titlePartButton">
        <div :class="$style.customSwiperButton" @click="moveSlide('prev', 'featuredSwiper')">
          <i class="fa fa-angle-left"></i>
        </div>
        <div :class="$style.customSwiperButton" @click="moveSlide('next', 'featuredSwiper')">
          <i class="fa fa-angle-right"></i>
        </div>
      </div>
    </div>
    <div class="swiper-container part-2 col-12 pa-bo-50">
      <swiper ref="featuredSwiper" :options="swiperOptions">
        <swiper-slide v-for="(course, index) in lessonData" :key="index">
          <LessonCard :key="course.id" :data="course" userType="other" />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import "swiper/css/swiper.css";
import LessonCard from '../components/lesson/LessonCard.vue';

export default {
  name: 'ProfileTeacherView',

  data() {
    return {
      userData: {
        firstname: '',
        lastname: '',
        imageUrl: '',
        links: [],
        education: [],
        degree: [],
      },
      lessonData: [],
      facebookLink: null,
      twitterLink: null,
      swiperOptions: {
        
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1024: { slidesPerView: 3, spaceBetween: 30 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          640: { slidesPerView: 1, spaceBetween: 10 },
        },
      },
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    LessonCard,

  },
  created() {
    this.fetchUserData();
    this.fetchLessonData();
  },

  methods: {
    fetchLessonData() {

      const user_id = this.$route.params.id;
      let params = { skip: 0, limit: 100, created_by: user_id };

      axios
        .get("/lessons", { params })
        .then((response) => {
          this.lessonData = response.data.items || [];
          console.log('this.lessonData', this.lessonData);

        })
        .catch((err) => {
          console.error("Error fetching lessons:", err);
        });
    },
    async fetchUserData() {
      const teacherId = this.$route.params.id;
      if (!teacherId) {
        console.error('Teacher ID is missing from route');
        this.$router.push('/'); // Redirect to home if teacherId is missing
        return;
      }

      try {
        const response = await axios.get(`/teacher_info/${teacherId}`);
        this.userData = {
          ...response.data,
          education: response.data.education || [],
          links: response.data.links || [],
          degree: response.data.degree || []
        };

        // Check if user_type is 2, otherwise redirect to '/'
        if (this.userData.user_type !== 2) {
          console.warn('User type is not allowed. Redirecting...');
          this.$router.push('/');
          return;
        }

        console.log("User data loaded:", this.userData);

        // Extract Facebook and Twitter links
        this.extractSocialLinks();

      } catch (error) {
        console.error('Failed to load user data:', error);
        this.$router.push('/'); // Redirect to home if API call fails
      }
    },

    extractSocialLinks() {
      this.facebookLink = this.userData.links.find(link => link.includes('facebook.com')) || null;
      this.twitterLink = this.userData.links.find(link => link.includes('twitter.com')) || null;
    },
    moveSlide(direction, swiperRef) {
      const swiper = this.$refs[swiperRef].$swiper;
      if (direction === 'prev') swiper.slidePrev();
      if (direction === 'next') swiper.slideNext();
    },
  }
};
</script>

<style module>
.container {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px;
}

/* Main Section */
.mainSection {
  display: flex;
  gap: 24px;
}

/* Image Section */
.imageSection {
  flex: 0 0 40%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profileImage {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--border-color);
}

.uploadPlaceholder {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background-color: var(--background-hover);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
}

/* Info Section */
.infoSection {
  flex: 0 0 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
}

.nameSection h2 {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary);
}

/* Social Links Section */
.linksSection {
  display: flex;
  gap: 16px;
  margin-top: 12px;
}

.btn {
  background-color: #3b5998;
  padding: 12px;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-twitter {
  background-color: #1da1f2;
}

.btn-facebook {
  background-color: #3b5998;
}

.btn i {
  font-size: 24px;
}

.btn:hover {
  opacity: 0.8;
}

/* Disabled State */
.disabled {
  background-color: #ccc !important;
  color: #999 !important;
  cursor: not-allowed;
  pointer-events: none;
}

/* Education Section */
.educationSection {
  padding-top: 24px;
}

.educationSection h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
}

.educationSection ul {
  list-style-type: none;
  padding: 0;
}

.educationSection li {
  padding: 12px;
  background-color: var(--background-hover);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background-color 0.3s;
}

.educationSection li:hover {
  background-color: var(--background-light);
}

.titlePart {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.titlePartButton {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-right: 16px;
  gap: 10px;
}

.customSwiperButton {
  position: relative;
  width: 30px;
  height: 30px;
  color: black;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background-color 0.3s ease;
}

.customSwiperButton:hover {
  background-color: rgba(0, 0, 0, 0.5);
}

.swiper-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Responsive Design */
@media (max-width: 768px) {
  .mainSection {
    flex-direction: column;
  }

  .imageSection {
    justify-content: center;
  }

  .infoSection {
    text-align: center;
  }

  .linksSection {
    justify-content: center;
  }
}
</style>
